import React from 'react';
import { ReceiptItem } from '../../../../types/receipts';
import { Table, Thead, Tbody, Tr, Th, Td } from '../../../../components/Table/Fake';
import styled from 'styled-components/macro';
import { SectionHeader } from '../../../common';
import { WithTranslation, withTranslation } from 'react-i18next';
import Discounts from './discounts';
import { getReceiptItemNetAmount } from '../../receiptHelpers';

interface ReceiptItemsProps extends WithTranslation{
    items?: ReceiptItem[];
    currency?: string;
}

interface RowProps {
    row: ReceiptItem;
    lng: string;
    currency?: string;
}

/*
 We need to use tables, flex or grid to display current design.
 CSS tables have no or minimal support for col/row spans.
 Since it's actual tabular data, go for table for now.
 */

const Row = (
    {
        row,
        lng,
        currency,
    }: RowProps
) => {
    return (
        <Tr as="tr">
            <ReceiptItemTd as="td">
                {row.id}
            </ReceiptItemTd>
            <ReceiptItemTd as="td">
                {row.description}
            </ReceiptItemTd>
            <ReceiptItemTd as="td">
                {row.quantity}
            </ReceiptItemTd>
            <ReceiptItemTd as="td">
                {getReceiptItemNetAmount(row, lng, currency)}
            </ReceiptItemTd>
        </Tr>
    );
};

const ReceiptItems = (
    {
        items,
        i18n,
        currency,
        t,
    }: ReceiptItemsProps
) => {
    if (!items) return null;
    const lng = i18n.language;
    return (
        <div>
            <SectionHeader>{t('customers.customer.receipt.fields.items')}</SectionHeader>
            <Table
                className="no-wrap"
                as="table"
            >
                <Thead as="thead">
                    <Tr as="tr">
                        <ReceiptTh as="th">{t('customers.customer.receipt.fields.id')}</ReceiptTh>
                        <ReceiptTh as="th">{t('customers.customer.receipt.fields.description')}</ReceiptTh>
                        <ReceiptTh as="th">{t('customers.customer.receipt.fields.quantity')}</ReceiptTh>
                        <ReceiptTh as="th">{t('customers.customer.receipt.fields.amount')}</ReceiptTh>
                    </Tr>
                </Thead>
                <ReceiptTbody as="tbody">
                    {items.map(item => {
                        return (
                            <React.Fragment key={item.id}>
                                <Row
                                    lng={lng}
                                    currency={currency}
                                    row={item}
                                />
                                {item.discount_lines && item.discount_lines.length > 0 && (
                                    <Discounts discounts={item.discount_lines} lng={lng} currency={currency}/>
                                )}
                            </React.Fragment>
                        );
                    })}
                </ReceiptTbody>
            </Table>
        </div>
    );
};

const ReceiptTh = styled(Th)`
    text-align: left;
    font-weight: 700;
`;

const ReceiptTbody = styled(Tbody)`
    border: none;
`;

const ReceiptItemTd = styled(Td)`
    &:after {
        display: none;
    }
`;

export default withTranslation()(ReceiptItems);
